import React from 'react';
import Text from '../../../Text';
export const OldPrice = _ref => {
  let {
    children,
    mode
  } = _ref;
  if (!children) {
    const oldPricePlaceholderStyle = {
      height: '16px'
    };
    return React.createElement("div", {
      style: oldPricePlaceholderStyle
    });
  }
  return React.createElement(Text.Caption, {
    tag: "p",
    className: "".concat(mode, " old-price")
  }, children);
};